import hcRequest from "@/helper/hc-request";
import urlcontext from '@/services/conf/axios.urlcontext';
import httphelper from '@/services/conf/httphelper'

export default {
    getConfiguration(){
        let activacion = new hcRequest();
        activacion.base = urlcontext.APP_AUTH_BASE;
        activacion.headers = httphelper.getCoreHeaders();
        activacion.authorization = httphelper.getToken();
        return activacion;
    }

}   